import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationProps {
  currentPage: number;
  hasMore: boolean;
  onPageChange: (page: number) => void;
  disabled?: boolean;
  total?: number;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  hasMore,
  onPageChange,
  disabled = false,
  total
}) => {
  const handlePrevious = () => {
    if (currentPage > 1 && !disabled) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (hasMore && !disabled) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="flex items-center justify-between px-4 py-3 theme-bg-primary">
      <div className="flex justify-between flex-1 sm:hidden">
        <button
          onClick={handlePrevious}
          disabled={currentPage === 1 || disabled}
          className={`relative inline-flex items-center px-4 py-2 text-sm font-medium rounded-md theme-transition
            ${currentPage === 1 || disabled
              ? 'theme-text-tertiary cursor-not-allowed'
              : 'theme-text-primary theme-bg-hover'
            }`}
        >
          上一页
        </button>
        <button
          onClick={handleNext}
          disabled={!hasMore || disabled}
          className={`relative inline-flex items-center px-4 py-2 text-sm font-medium rounded-md theme-transition
            ${!hasMore || disabled
              ? 'theme-text-tertiary cursor-not-allowed'
              : 'theme-text-primary theme-bg-hover'
            }`}
        >
          下一页
        </button>
      </div>
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm theme-text-primary">
            第 <span className="font-medium">{currentPage}</span> 页
            {total !== undefined && total > 0 && (
              <span>，共 <span className="font-medium">{total}</span> 条</span>
            )}
          </p>
        </div>
        <div>
          <nav className="inline-flex -space-x-px rounded-md theme-shadow-sm" aria-label="分页">
            <button
              onClick={handlePrevious}
              disabled={currentPage === 1 || disabled}
              className={`relative inline-flex items-center px-2 py-2 rounded-l-md border theme-transition
                ${currentPage === 1 || disabled
                  ? 'theme-text-tertiary cursor-not-allowed theme-bg-secondary'
                  : 'theme-text-secondary theme-bg-hover'
                } theme-border-primary`}
            >
              <span className="sr-only">上一页</span>
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button
              onClick={handleNext}
              disabled={!hasMore || disabled}
              className={`relative inline-flex items-center px-2 py-2 rounded-r-md border theme-transition
                ${!hasMore || disabled
                  ? 'theme-text-tertiary cursor-not-allowed theme-bg-secondary'
                  : 'theme-text-secondary theme-bg-hover'
                } theme-border-primary`}
            >
              <span className="sr-only">下一页</span>
              <ChevronRight className="h-5 w-5" />
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Pagination; 